import { render, staticRenderFns } from "./MailTemplateList.vue?vue&type=template&id=5165a1e4"
import script from "./MailTemplateList.vue?vue&type=script&lang=js"
export * from "./MailTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports